import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const categories = ['Tarot', 'Péndulo & Radiestesia', 'Reiki & Energía', 'Registros Akáshicos', 'Constelaciones & Biodecodificación', 'Chakras', 'Limpiezas Energéticas', 'Numerología', 'Aromaterapia', 'Runas', 'Feng Shui', 'Flores de Bach'];
export function AccordionSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 bg-white border-t border-gray-100" data-id="element-15">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif font-bold text-center text-black mb-8" data-id="element-17">
          Tocá cada terapia y descubrí todo lo que te llevás
        </motion.h2>

        <div className="space-y-2 mb-8" data-id="element-18">
          {categories.map((category, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-20">
                <span className="font-serif text-base font-bold text-gray-900" data-id="element-21">
                  {category}
                </span>
                <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-24">
                    <div className="px-4 pb-4 pt-0 text-gray-600" data-id="element-25">
                      <div className="w-full h-px bg-gray-100 mb-3" data-id="element-26" />
                      <p className="text-sm" data-id="element-27">
                        Incluye cursos y manuales para aprender, aplicar y
                        profundizar en {category.toLowerCase()}.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brown/5 border border-brown/10 p-5 rounded-xl text-center" data-id="element-28">
          <p className="font-serif font-bold text-base text-brown" data-id="element-29">
            Y esto es solo la punta del iceberg: el Pack incluye +70 recursos en
            total.
          </p>
        </motion.div>
      </div>
    </section>;
}